import { useEffect, useState } from 'react';

export const useInitialMountDelay = (delayMs = 500) => {
  const [isReady, setIsReady] = useState(delayMs === 0);

  useEffect(() => {
    if (delayMs === 0) return;
    const t = setTimeout(() => setIsReady(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  return isReady;
};

